module.exports = __webpack_public_path__ + "img/光良.7519e6df.png";